import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import i18n from "@gik/i18n";
import { SvgIcon } from "@gik/ui-legacy/SvgIcon/SvgIcon";
import type { ITableProps } from "@gik/ui-legacy/Table";
import { StickyTable } from "@gik/ui-legacy/Table";
import CheckCircleIcon from "@heroicons/react/solid/CheckCircleIcon";
import React from "react";
import { competitors } from "../constants/competitors";

interface ICompetitorsTableItem {
	id: string;
	name?: string;
	description: React.ReactNode;
	useStickyHeader?: boolean;
}

export interface ICompetitorsComparisonTableProps<T extends object>
	extends Omit<ITableProps<T>, "data" | "columns"> {}

const blockName = "competitors-comparison-table";

function CompetitorsComparisonTableComp<T extends object>({
	className,
	hasStickyHeader: useStickyHeader = true,
}: ICompetitorsComparisonTableProps<T>): React.ReactElement {
	const bem = bemBlock(blockName);

	const allColumns = [
		{
			Header: (
				// <Image
				//   className={bem('gik-logo')}
				//   asBackground
				//   proportion={new Proportion(199, 58)}
				//   src={`${getAssetsUrl()}core/img/icons/giveinkind-logo.svg`}
				// />
				<div className={bem("gik-logo")}>Give InKind</div>
			),
			accessor: "description",
			sticky: "left",
		},
		...competitors
			.filter((item) => item.id !== "giveinkind")
			.map((competitor) => {
				return {
					Header: competitor.name,
					accessor: competitor.id,
				};
			}),
	];

	// create table data from the competitors collection
	const data: ICompetitorsTableItem[] = React.useMemo(() => {
		return Object.keys(competitors[0].features).map((featureKey) => {
			const competitorFeatures = {};
			competitors.forEach((competitor) => {
				const svgClassName =
					competitor.id === "giveinkind" ? "gik-checkmark" : "checkmark";
				competitorFeatures[competitor.id] = competitor.features[featureKey] ? (
					<SvgIcon Icon={CheckCircleIcon} className={svgClassName} />
				) : (
					""
				);
			});

			const model = {
				id: featureKey,
				description: (
					<div className="gik-competitors-comparison-table__firstCol">
						<main>{i18n.t(`marketing-features.${featureKey}`) as string}</main>
						<aside>
							<SvgIcon Icon={CheckCircleIcon} className="gik-checkmark" />
						</aside>
					</div>
				),
				...competitorFeatures,
			};

			return model;
		});
	}, []);

	return (
		<StickyTable
			useStickyHeader={useStickyHeader}
			data={data}
			columns={allColumns}
			className={bem(null, null, className)}
			fullWidth
		/>
	);
}

export const CompetitorsComparisonTable = withComponentErrorBoundary(
	CompetitorsComparisonTableComp,
);
